import * as React from 'react';
import { styled } from '@mui/material/styles';
import Collapse from '@mui/material/Collapse';
import { ScoringInformationDto } from 'models/dtoTypes';
import Link from '@mui/material/Link';
import MuiAlert, { AlertProps } from '@mui/material/Alert';

const PREFIX = 'QuestionActionContainer';

const classes = {
  inputGroup: `${PREFIX}-inputGroup`,
  scoreInformation: `${PREFIX}-scoreInformation`,
};

const Root = styled('div')(({ theme }) => ({
  [`& .${classes.inputGroup}`]: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),

    '& > *': {
      width: '100%',
    },
  },

  [`&.${classes.scoreInformation}`]: {
    width: '100%',
    paddingBottom: theme.spacing(2),
    color: 'white',
    borderRadius: 2,
  },
}));

function Alert(props: AlertProps) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

type Severity = 'success' | 'warning' | 'info' | 'error';

interface Props {
  action: ScoringInformationDto;
}

function QuestionActionContainer(props: Props): JSX.Element {
  const { action } = props;
  const [openAction, setOpenAction] = React.useState(true);

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    // do nothing
  };

  const renderAction = () => {
    const mapper = {
      Info: 'info',
      Success: 'success',
      Warning: 'warning',
      Danger: 'error',
    };
    const { actionable, message, type } = action;
    return (
      <Collapse in={openAction}>
        <Alert
          onClose={() => setOpenAction(false)}
          severity={(type ? mapper[type] : 'info') as Severity}
        >
          {actionable ? (
            <Link underline="hover" variant="body2" color="inherit" onClick={handleClick}>
              {message}
            </Link>
          ) : (
            message
          )}
        </Alert>
      </Collapse>
    );
  };

  return (
    <Root className={classes.scoreInformation}>
      {renderAction()}
    </Root>
  );
}

export default QuestionActionContainer;
